import React, { useContext } from "react";
import checkmark from "./checkmark.png";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import { UserContext } from "./Context";
import Card from "./Card";

const againBtn = {
  background: " rgb(214, 235, 243)",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  color: "rgb(1, 1, 77)",
  fontWeight: "bold",
  fontSize: "1.1em",
};

const redBtn = {
  backgroundColor: " rgb(239, 187, 178)",
  color: "rgb(0, 0, 0)",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  fontWeight: "bold",
  marginTop: "1em",
  marginLeft: "5em",
  fontSize: "1.1em",
};

const greenBtn = {
  backgroundColor: "rgb(166, 237, 208)",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  color: "rgb(1, 1, 77)",
  fontWeight: "bold",
  marginTop: "1em",
  fontSize: "1.1em",
};

const checkmarkStyle = {
  width: "6em",
  borderRadius: "20px",
};

const customStyle = {
  color: "rgb(72, 31, 42)",
  backgroundColor: "rgb(245, 239, 227)",
};

const Success = () => {
  const navigate = useNavigate();
  const { loggedInUser } = useContext(UserContext);

  const handleLogout = async () => {
    console.log("Logging out...");
    try {
      await signOut(auth);
      console.log("Logged out successfully");
      navigate("/Login");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Card customStyle={customStyle} header="Balance">
      <div>
        <h5 className="success-title">Success</h5>
        <img
          style={checkmarkStyle}
          className="checkmark"
          src={checkmark}
          alt="success checkmark"
        />
        <hr />
        <button style={againBtn} className="btn" onClick={handleLogout}>
          Logout
        </button>

        <br />
        <Link to="/Deposit" className="btn" style={greenBtn}>
          Deposit
        </Link>
        <Link to="/Withdraw" className="btn" style={redBtn}>
          Withdraw
        </Link>
      </div>
    </Card>
  );
};

export default Success;
